export default {
  recommendedShopsTitle: {
    au: 'Browse More Gear from Top Shops in Australia',
    br: 'Browse More Gear from Top Shops in Brazil',
    ca: 'Browse More Gear from Top Shops in Canada',
    eu: 'Browse More Gear from Top Shops in the EU',
    gb: 'Browse More Gear from Top Shops in the UK',
    no: 'Browse More Gear from Top Shops in Norway',
    default: 'Browse Top Shops',
  },
};
